<script>
import {
  pageCommanderCreationCompteProps,
  usePageCommanderCreationCompte
} from "./mixin";
import InscriptionForm from "@/containers/compte-client/inscription-form";
import Container from "@/components/atoms/container";
import LazyImage from "@/components/atoms/lazy-image";
import GridCol from "@/components/molecules/grid/grid-col";
import GridRow from "@/components/molecules/grid/grid-row";
import Connexion from "@/containers/connexion/connexion-panier";
import ErreurCreationCarteFidelite from "@/components/organisms/erreur-creation-carte-fidelite";
import Popin from "@/components/molecules/popin";
import customerAccountBgLogo from "@/assets/images/customer-account-bg-logo.jpg";

export default {
  components: {
    InscriptionForm,
    GridCol,
    GridRow,
    Container,
    LazyImage,
    Connexion,
    ErreurCreationCarteFidelite,
    Popin
  },
  props: {
    ...pageCommanderCreationCompteProps()
  },
  setup() {
    const erreurCreationCarte = ref(null);
    const {
      carteDejaExistante,
      handleAccountCreated,
      redirectToCommander,
      redirectToSuccess,
      mounted
    } = usePageCommanderCreationCompte(erreurCreationCarte);

    onMounted(mounted);

    return {
      carteDejaExistante,
      handleAccountCreated,
      redirectToCommander,
      redirectToSuccess,
      erreurCreationCarte,
      customerAccountBgLogo
    };
  },
  methods: {
    showConnexion() {
      this.$refs.connexionForm.show();
    }
  }
};
</script>

<template>
  <div
    id="content"
    role="main"
  >
    <Connexion
      ref="connexionForm"
      :type-panier="typePanier"
    />
    <Container class="u-bgcolor-white">
      <GridRow>
        <GridCol
          cols="3"
          class="o-col--no-gutter"
        >
          <LazyImage
            :src="customerAccountBgLogo"
            alt="bandeau de confirmation"
            class="form-inscription-illustration"
            width="327"
            height="981"
          />
        </GridCol>
        <GridCol cols="9">
          <InscriptionForm
            :is-in-tunnel="isInTunnel"
            class="u-mt-lg u-ml-xlg"
            @accountCreated="handleAccountCreated"
            @showAuth="showConnexion()"
            @magasinSwitched="redirectToSuccess"
          />
        </GridCol>
      </GridRow>
    </Container>
    <Popin
      ref="erreurCreationCarte"
      @cancelled="redirectToCommander"
    >
      <ErreurCreationCarteFidelite :carte-deja-existante="carteDejaExistante" />
    </Popin>
  </div>
</template>

<style lang="scss" scoped>
.form-inscription-illustration,
.form-inscription-illustration :deep(img) {
  position: sticky;
  top: 0;
  height: 100vh;
  -o-object-fit: cover;
  object-fit: cover;
  @include ie() {
    width: 100%;
    height: auto;
  }
}
</style>
